import React from 'react'

export default props => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
        <circle fill="#009245" cx="11" cy="11" r="11" />
        <path
            fill="#fff"
            d="M965.13,544.23v-5.11h1.3v5.11a1.35,1.35,0,0,1-1.3,1.29h-9a1.33,1.33,0,0,1-1.29-1.29v-9a1.33,1.33,0,0,1,1.29-1.29h6.4v1.29h-6.4v9ZM958,538.52l2,2,5.5-5.5.91.9L960,542.3l-2.88-2.88Z"
            transform="translate(-949.18 -529.01)"
        />
    </svg>
)
